import Azguard from "@/components/Icons/Wallets/Azguard"

const KnownAztecConnectors = [
    {
        id: 'azguard-wallet',
        name: 'Azguard',
        icon: Azguard
    },
    {
        id: 'azguard wallet',
        name: 'Azguard',
        icon: Azguard
    },
    {
        id: 'azguard',
        name: 'Azguard',
        icon: Azguard
    },
]

export default KnownAztecConnectors